import './app.css';
// import '../assets/fonts/entero/font-style.css';
// import '../assets/fonts/entero/demo';
import 'bootstrap';
// import './polyfills';
import 'core-js/es7/reflect';
// import * as $ from 'jquery';
import 'datatables.net/js/jquery.dataTables';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import '../../node_modules/jquery/dist/jquery';

import { LicenseManager } from 'ag-grid-enterprise';
LicenseManager.setLicenseKey("OrderGenie_Synergy_Pvt_Ltd__MultiApp_1Devs_1Deployment_20_March_2020__MTU4NDY2MjQwMDAwMA==9f63ad49a34547b9b056cce9fe224840");
// import '../assets/Lightweight-Drilldown-Menu-Plugin-with-jQuery-Bootstrap/js/bootstrap-drilldown-select';
// depending on the env mode, enable prod mode or add debugging modules
if (process.env.NODE_ENV === 'production') {
    enableProdMode();
}

import { AppModule } from './app.module';

export function main() {
    return platformBrowserDynamic().bootstrapModule(AppModule);
}

if (document.readyState === 'complete') {
    main();
} else {
    document.addEventListener('DOMContentLoaded', main);
}


